import { useGetCoachAllLectures } from '#api/lectures';
import { Button } from '#atoms';
import { PATH } from '#const/path';
import usePatchCurrentStepMutation from '#hooks/queries/onboard/usePatchCurrentStepMutation';
import { FloatButtonContainer } from '#molecules';
import { useUserInfo } from '#providers/UserInfo';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router';
import { useOnBoardStep } from '../../OnBoardStep.hooks';
import Item from '../Step5/components/Item';
import * as S from '../Step5/styles';

export default function Step8() {
  const navigate = useNavigate();
  const { setStep } = useOnBoardStep();
  const { userInfo } = useUserInfo();
  const { data: lectures } = useGetCoachAllLectures(userInfo?.id ?? '');
  const { mutateAsync: patchCurrentStep } = usePatchCurrentStepMutation();

  const handleNext = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'onboarding_lectureadded_next_click',
        category: '신규가입 온보딩',
        action: 'onboarding_lectureadded_next_click',
        value: 2
      }
    });
    patchCurrentStep(9);
    setStep(9);
  };
  return (
    <>
      <S.Wrapper>
        <S.Title>
          운영하는 수업을{'\n'}
          등록해 주세요
        </S.Title>
        <S.ItemWrapper direction="column" gap={8}>
          {lectures?.data?.map(lecture => (
            <Item key={lecture.id} lecture={lecture} />
          ))}
        </S.ItemWrapper>
        <S.Add
          onClick={() => {
            TagManager.dataLayer({
              dataLayer: {
                event: 'onboarding_addlecture_click',
                category: '신규가입 온보딩',
                action: 'onboarding_addlecture_click',
                value: 2
              }
            });
            navigate(PATH.ONBOARD_LECTURE);
          }}
        >
          <div style={{ paddingTop: '4px' }}>
            <PlusIcon />
          </div>
          수업추가
        </S.Add>
      </S.Wrapper>
      <FloatButtonContainer>
        <Button
          onClick={handleNext}
          disabled={!lectures || lectures.data.length < 1}
        >
          다음으로
        </Button>
      </FloatButtonContainer>
    </>
  );
}

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.16669 10.8334H4.16669V9.16669H9.16669V4.16669H10.8334V9.16669H15.8334V10.8334H10.8334V15.8334H9.16669V10.8334Z"
      fill="#EAE8ED"
    />
  </svg>
);
